module.exports = __webpack_public_path__ + "static/img/image016.0d80582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image016.png
// module id = cTO5
// module chunks = 1